import { useEffect } from 'react';

/**
 * Component to set the page title
 * @param {Object} props
 * @param {string} props.title - The title to set
 * @param {string} [props.suffix='App Analysis System'] - Optional suffix to append to the title
 */
const PageTitle = ({ title, suffix = 'App Analysis System' }) => {
  useEffect(() => {
    // Update the document title
    document.title = title ? `${title} | ${suffix}` : suffix;
    
    // Restore the original title when component unmounts
    return () => {
      document.title = suffix;
    };
  }, [title, suffix]);

  // This component doesn't render anything
  return null;
};

export default PageTitle; 